// src/pages/sow-template/PlaceholderModal.jsx
import PropTypes from "prop-types";
import { Button, FormField, Input, Modal, Select } from "../../shared/ui";

const TYPE_OPTIONS = [
  { value: "string", label: "String" },
  { value: "number", label: "Number" },
  { value: "date", label: "Date" },
  { value: "email", label: "Email" },
];

export default function PlaceholderModal({
  open,
  onClose,
  editingKey,
  phKey,
  onKeyChange,
  phLabel,
  onLabelChange,
  phType,
  onTypeChange,
  phRequired,
  onRequiredChange,
  onSave,
}) {
  return (
    <Modal
      open={open}
      title={editingKey ? `Edit Placeholder: ${editingKey}` : "Add Placeholder"}
      onClose={onClose}
      footer={<Button onClick={onSave}>Save Placeholder</Button>}
    >
      <div className="flex flex-col gap-4">
        <FormField label="Key" required helperText="Letters, numbers, underscore only">
          <Input value={phKey} onChange={(e) => onKeyChange(e.target.value)} placeholder="client_name" />
        </FormField>
        <FormField label="Label">
          <Input value={phLabel} onChange={(e) => onLabelChange(e.target.value)} placeholder="Client Name" />
        </FormField>
        <div className="flex items-end gap-4">
          <div className="flex-1">
            <FormField label="Type">
              <Select options={TYPE_OPTIONS} value={phType} onChange={(e) => onTypeChange(e.target.value)} />
            </FormField>
          </div>
          <label className="flex items-center gap-2 text-sm text-slate-700 pb-2.5">
            <input
              type="checkbox"
              checked={phRequired}
              onChange={(e) => onRequiredChange(e.target.checked)}
              className="w-4 h-4 accent-blue-600"
            />
            Required
          </label>
        </div>
      </div>
    </Modal>
  );
}

PlaceholderModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  editingKey: PropTypes.string,
  phKey: PropTypes.string.isRequired,
  onKeyChange: PropTypes.func.isRequired,
  phLabel: PropTypes.string.isRequired,
  onLabelChange: PropTypes.func.isRequired,
  phType: PropTypes.string.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  phRequired: PropTypes.bool.isRequired,
  onRequiredChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
